import classNames from 'classnames';
import React, { PureComponent, PropTypes } from 'react';
import { withStyle } from '../../utils/Decorator';

@withStyle(require('./Glyph.styl'))
export default class Glyph extends PureComponent {
  static displayName = 'Glyph';

  static propTypes = {
    name: PropTypes.string.isRequired,
    className: PropTypes.string,
  };

  render = () => (
    <svg className={classNames('Glyph', this.props.className)}>
      <use xlinkHref={`#${this.props.name}`} />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/app/components/Glyph/Glyph.jsx